'use client';

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from 'react';
import { usePageLayout } from '@libs/common-next';
import { handleServiceClick, isServicesLink } from '@libs/experience-api';
type ServicesLinkClickOptions = {
  event: MouseEvent;
  link?: string;
  shouldOpenInNewTab?: boolean;
};
function shouldOpenServicesInNewTab(event: MouseEvent, shouldOpenInNewTab?: boolean) {
  return Boolean(shouldOpenInNewTab || event.metaKey || event.ctrlKey || event.shiftKey);
}
export function useServicesLinkClick() {
  const $ = _c(2);
  const {
    isAuthenticated
  } = usePageLayout();
  let t0;
  if ($[0] !== isAuthenticated) {
    t0 = t1 => {
      const {
        event,
        link,
        shouldOpenInNewTab
      } = t1;
      if (!isAuthenticated || !isServicesLink(link)) {
        return;
      }
      handleServiceClick({
        authType: isAuthenticated,
        event,
        link,
        shouldOpenInNewTab: shouldOpenServicesInNewTab(event, shouldOpenInNewTab)
      });
    };
    $[0] = isAuthenticated;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}